<div class="mb-3 rounded-sm border border-blue-300 bg-blue-100 p-4">
  <ng-content />
</div>
